export default __webpack_public_path__ + "static/media/SD-36.cb953676.jpg";